export default "__VITE_ASSET__61cfde51__"